import {ref} from 'vue'
import {Product} from '@/products/product.types'
import {getRandomNoun} from '@/services/random.service'
import {capitalize} from 'lodash'
import {get, post, put} from '@/services/infrastructure/api.service'
import emitter from '@/services/infrastructure/emitter'
import {ORG_SELECTED} from '@/types/events'
import {v4 as uuidv4} from 'uuid'

const PRODUCTS_PATH = '/products'

const products = ref<Product[]>([])
const generateRandomProducts = (count: number) => {
    const newProducts = []
    for (let i = 0; i < count; i++) {
        const name = capitalize(getRandomNoun())
        newProducts.push({
            uuid: uuidv4(),
            name,
            code: name.substring(0, 5).toUpperCase(),
            description: `Random description for ${name}`,
            retailPrice: 10 + Math.random() * 100,
            accountNo: '3000',
            active: Math.random() > 0.2,
            metadata: {}
        })
    }

    return newProducts
}

const getProductByUuid = (uuid: string) => {
    return products.value.find(product => product.uuid === uuid)
}

const getDefaultNewProduct = () => {
    return {
        uuid: '',
        name: '',
        code: '',
        retailPrice: 0,
        accountNo: '3000',
        active: true,
        metadata: {}
    }
}

const saveProduct = async (product: Product) => {
    const existingIndex = products.value.findIndex(p => p.uuid === product.uuid)
    if (existingIndex > -1) {
        return await putProduct(product)
    } else {
        return await postProduct(product)
    }
}

const postProduct = async (product: Product) => {
    return await post(PRODUCTS_PATH, product)
}

const putProduct = async (product: Product) => {
    return await put(PRODUCTS_PATH, product)
}

let initialized = false
const fetchProducts = async () => {
    products.value = await get<Product[]>(PRODUCTS_PATH) ?? []
}

// @ts-ignore
if (window.Cypress) {
    // @ts-ignore
    window.apiProductPost = postProduct
    // @ts-ignore
    window.apiFetchProducts = fetchProducts
}

export const useProducts = () => {
    if (!initialized) {
        emitter.on(ORG_SELECTED, fetchProducts)
        fetchProducts()
        initialized = true
    }

    return {
        products,
        getProductByUuid,
        generateRandomProducts,
        getDefaultNewProduct,
        saveProduct,
        fetchProducts
    }
}
